<template>
  <v-app>
    <v-container fluid class="my-4 google-font">
      <v-layout align-center justify-center row>
        <v-flex xs12 md8 xl6>
          <v-card class="pa-4">
            <div class="home-section-title mb-4">Publications</div>
            <div class="my-4">
              BugSeq is proud to support our users who publish innovative work.
              If you are interested in using BugSeq for a publication, please
              contact
              <a href="mailto:support@bugseq.com">support@bugseq.com</a>.
            </div>
            <div class="mb-3 mt-5">
              <b><v-icon class="mr-2" color="black">push_pin</v-icon>Pinned</b>
            </div>
            <Publication
              v-for="publication in publications.filter((p) => p.pinned)"
              :key="publication.id"
              :publication="publication"
            />
            <div v-for="year in getYears()">
              <div class="mb-3 mt-5">
                <b>{{ year }}</b>
              </div>
              <Publication
                v-for="publication in getPublications(year)"
                :key="publication.id"
                :publication="publication"
              />
            </div>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
// publications.json is created by exporting from a Zotero collection in JSON format
import publicationsRaw from "@bugseq-site/www/src/assets/data/publications/publications.json";
import { type Publication as PublicationType, type DateTuple } from "@bugseq-site/www/src/lib/types";
import Publication from "@bugseq-site/www/src/components/publications/Publication.vue";

function parseRawDate(raw: (number | string)[]): DateTuple {
  const numeric = raw.map(v => typeof v === "string" ? parseInt(v, 10) : v);
  const [year, month = 1, day = 1] = numeric as number[];
  return [year, month, day] as DateTuple;
}

@Component({
  metaInfo() {
    return {
      title: "Publications",
    };
  },
  components: {
    Publication,
  },
})
export default class PublicationsPage extends Vue {
  private publications: PublicationType[]
  private pinnedPublications = new Set(["http://zotero.org/users/5058348/items/MGQZUHD6", "http://zotero.org/users/5058348/items/2YPGG8II", "http://zotero.org/users/5058348/items/UZD6KE5Q", "http://zotero.org/users/5058348/items/L4YPB3UZ"])

  constructor() {
    super()

    // filter out if there is no URL
    this.publications = publicationsRaw.map(p => {
      return {
        ...p,
        issued: { "date-parts": [parseRawDate(p.issued!["date-parts"][0])] },
        pinned: this.pinnedPublications.has(p.id),
      }
    })
  }

  public getYears() {
    return Array.from(
      new Set(this.publications.filter((p) => !p.pinned).map((p) => p.issued["date-parts"][0][0])),
    )
      .sort()
      .reverse();
  }

  public getPublications(year) {
    return this.publications
      .filter((p) => !p.pinned)
      .filter((p) => p.issued["date-parts"][0][0] === year)
      .sort((p0, p1) => {
        const [p0y, p0m, p0d] = p0.issued["date-parts"][0]
        const [p1y, p1m, p1d] = p1.issued["date-parts"][0]

        if (p0y !== p1y) return p1y - p0y
        if (p0m !== p1m) return p1m - p0m
        return p1d - p0d
      });
  }
}
</script>
